import * as React from 'react'
import classNames from 'classnames'
// @ts-ignore
import Trigger from 'rc-trigger'
import { UserBoxMenu } from './menu'
import { directionSensitivePopupAlign } from 'carpool_shared/utils/bidi'
import 'rc-trigger/assets/index.css'
import * as styles from './style.module.scss'

interface IUserBoxContentProps {
  userName: string
  imageUrl?: string
  email?: string
  headerPictureSize?: number
}

const defaultHeaderPictureSize = 37

// Offset of the tip of balloon (to make it center with header picture)
const tipPointOffset = 27

const align = (headerIconSize: number) =>
  directionSensitivePopupAlign(['tr', 'br'], [tipPointOffset - headerIconSize / 2, 20])

export class UserBoxContent extends React.Component<IUserBoxContentProps, { open: boolean }> {
  public state = { open: false }

  public render() {
    const headerPictureSize = this.props.headerPictureSize || defaultHeaderPictureSize
    return (
      <Trigger
        action={['click']}
        destroyPopupOnHide
        popup={
          <UserBoxMenu
            userName={this.props.userName}
            imageUrl={this.props.imageUrl}
            email={this.props.email}
          >
            {this.props.children}
          </UserBoxMenu>
        }
        popupAlign={align(headerPictureSize)}
        popupVisible={this.state.open}
        onPopupVisibleChange={() => {
          this.setState(state => ({ open: !state.open }))
        }}
        popupClassName={styles.menu}
      >
        <div>
          <div
            className={classNames(styles.headerPhotoPlaceholder, styles.headerPhoto)}
            style={{
              backgroundImage: this.props.imageUrl ? `url(${this.props.imageUrl})` : '',
              backgroundSize: headerPictureSize,
              width: headerPictureSize,
              height: headerPictureSize
            }}
            data-test-id='header-photo-placeholder'
          />
        </div>
      </Trigger>
    )
  }
}
